import { jsx as _jsx } from "react/jsx-runtime";
import { getAllSites, loadAllSites, logger } from '@vista/omnichannel-components-domain';
import { useMountEffect } from '@vista-digital/react-tools';
import { observer } from 'mobx-react';
import { useContext, useState } from 'react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { siteCompareFn } from '../../site-picker/utils/site-utils';
import { QuickNavigatorContextInstance } from '../types/context';
import { DropdownType, QuickNavigatorDropdown } from './dropdown';
export const QuickNavigatorSiteDropdown = observer(() => {
    const i18n = useI18n();
    const { displayText, config, assets } = useContext(QuickNavigatorContextInstance);
    const allSites = getAllSites();
    const sortedSites = allSites ? [...allSites].sort((siteA, siteB) => siteCompareFn(siteA, siteB, i18n)) : [];
    const dropdownOptions = getDropdownOptionsForSites(sortedSites, i18n);
    const [messageType, setMessageType] = useState();
    const [isLoading, setIsLoading] = useState(false);
    useMountEffect(() => {
        (async () => {
            setIsLoading(true);
            try {
                await loadAllSites();
                setMessageType(undefined);
            }
            catch (error) {
                logger.error(error);
                setMessageType(QuickNavigatorSiteDropdownMessageType.FailedToLoadSites);
            }
            finally {
                setIsLoading(false);
            }
        })();
    });
    const messageProps = getQuickNavigatorSiteDropdownMessageProps(messageType, assets, displayText);
    return (_jsx(QuickNavigatorDropdown, Object.assign({}, messageProps, { type: DropdownType.Site, options: dropdownOptions, loading: isLoading, enableSearch: config.sites.enableSearch, placeholder: displayText.siteDropdownPlaceholder, label: displayText.siteDropdownLabel, modal: Object.assign(Object.assign({}, messageProps === null || messageProps === void 0 ? void 0 : messageProps.modal), { displayAsModalOnMobile: config.sites.displayAsModalOnMobile, heading: displayText.siteModalHeading, searchInputPlaceholder: displayText.siteModalSearchInputPlaceholder, noSearchResultsFoundMessage: displayText.noSiteSearchResultsFoundModalMessage, noSearchResultsFoundIconName: assets.noSitesFoundModalIconName }), noSearchResultsFoundMessage: displayText.noSitesFoundErrorMessage })));
});
QuickNavigatorSiteDropdown.displayName = 'QuickNavigatorSiteDropdown';
const getDropdownOptionsForSites = (sites, i18n) => {
    return sites.map(site => {
        return {
            text: i18n.translatable(site.name),
            value: site.id
        };
    });
};
var QuickNavigatorSiteDropdownMessageType;
(function (QuickNavigatorSiteDropdownMessageType) {
    QuickNavigatorSiteDropdownMessageType["FailedToLoadSites"] = "FailedToLoadSites";
})(QuickNavigatorSiteDropdownMessageType || (QuickNavigatorSiteDropdownMessageType = {}));
const getQuickNavigatorSiteDropdownMessageProps = (messageType, assets, displayText) => {
    switch (messageType) {
        case QuickNavigatorSiteDropdownMessageType.FailedToLoadSites:
            return {
                errorMessageHelpText: displayText.failedToLoadSitesErrorMessage,
                modal: {
                    errorTitle: displayText.failedToLoadSitesModalErrorTitle,
                    errorMessage: displayText.failedToLoadSitesModalErrorMessage,
                    errorIconName: assets.failedToLoadSitesModalErrorIconName
                }
            };
        default:
            return undefined;
    }
};
